// extracted by mini-css-extract-plugin
export default {"button":"button-primary_button__hEuLr","text":"button-primary_text__vpsXm","buttonDisabled":"button-primary_buttonDisabled__iBjQ1"};